export function sortCaseInsensitive(arr: string[]) {
  const res = arr.slice()
  return res.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
}

interface IItemWithName {
  name: string
}

/**
 * When filtering items in the Select component, this function is used to determine if an item matches the query.
 * @param query Term entered by the user to filter the items.
 * @param item The item to be tested against the query.
 * @returns True if the item matches the query, false otherwise.
 */
export function itemPredicate(
  query: string,
  item: IItemWithName | string,
): boolean {
  if (!item || !query) return true

  if (typeof item === 'string') {
    return item.toLowerCase().includes(query.toLowerCase())
  }
  return item.name.toLowerCase().includes(query.toLowerCase())
}
